<template>
<div class="playlist px-2">
    <div class="title p-3 border-bottom">
        <h4 class="font-weight-light">Lista de reproducción</h4>
        <span id="video__count">{{videos ? videos.length : 0}} Vídeos Publicados</span>
    </div>
    <div class="video d-flex border-bottom p-0" v-for="video in videos" :key="video.id" @click="play(video)">
        <div class="text-left m-2">
            <i class="fas fa-play b-white rounded-circle p-2"></i> {{video.title}}
        </div>
    </div>
</div>
</template>
<style scoped>
    .video:hover{
        cursor: pointer;
        opacity: .5
    }
</style>
<script>
export default {
    name: 'PlayListVideo',
    props: {
        videos: Array
    },
    data() {
        return {

        }
    },
    methods: {
        play(video){
            this.$parent.loadVideo(video.cover, video.video, video.description)
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/#public/curse/components/content/PlayListVideo.vue